var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenAlertFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66667 23.3333H0V0H20L15.1667 7.5L20 15H1.66667V23.3333Z",
    fill: "#6FCF97"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenAlertFlag);
export default __webpack_public_path__ + "static/media/green-alert-flag.e5001305183daf932d7464751be6bc82.svg";
export { ForwardRef as ReactComponent };